import * as joint from '@joint/plus'
import AceLayer from '../rappid/ace-layer'

export default class RappidContext {
  paper!: joint.dia.Paper

  paperScroller!: joint.ui.PaperScroller

  graph!: joint.dia.Graph

  create(this: RappidContext): void {
    this.createGraph()
    this.createPaper()
    this.createPaperScroller()
    new joint.ui.Tooltip({
      target: '[data-tooltip]',
      padding: 10,
      direction: joint.ui.Tooltip.TooltipArrowPosition.Auto,
      rootTarget: document.body,
    })
    //For debugging:
    //window.graph = this.graph
  }

  mount(this: RappidContext, canvas: HTMLDivElement): void {
    canvas.appendChild((this.paperScroller as any).el)

    // Center and zoom the graph.
    // For some event loop issue we didn't figure out a timeout of 0ms is needed for this to work.
    setTimeout(() => {
      this.paperScroller.zoomToFit({
        padding: { left: 20, top: 20, right: 20, bottom: 20 },
        maxScale: 1,
      })
    }, 0)

    const aceLayer = new AceLayer(this)
    aceLayer.init()

    this.paper.unfreeze()
  }

  private createGraph(this: RappidContext) {
    this.graph = new joint.dia.Graph({}, { cellNamespace: joint.shapes })
  }

  private createPaper(this: RappidContext) {
    this.paper = new joint.dia.Paper({
      model: this.graph,
      width: 800,
      height: 800,
      gridSize: 10,
      drawGrid: false,
      defaultConnector: {
        name: 'normal',
        args: {
          radius: 20,
        },
      },
      defaultAnchor: function (view, magnet, ref, opt, endType, linkView) {
        if (endType === 'source') {
          return joint.anchors.left(view, magnet, ref, opt, endType, linkView)
        } else {
          return joint.anchors.right(view, magnet, ref, opt, endType, linkView)
        }
      },
      routerNamespace: joint.routers,
      interactive: {
        elementMove: false, // Containers are not movable
      },
      background: {
        color: '#F2F2F2',
      },
      frozen: true,
      async: true,
      sorting: joint.dia.Paper.sorting.APPROX,
      linkPinning: true,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      allowLink(linkView: any, paper: any) {
        return linkView.getTargetElement() != null && linkView.getSourceElement() != null
      },
      cellViewNamespace: joint.shapes,
    })
  }

  private createPaperScroller() {
    this.paperScroller = new joint.ui.PaperScroller({
      paper: this.paper,
      autoResizePaper: true,
      borderless: true,
      scrollWhileDragging: true,
      cursor: 'grab',
    })
  }
}
